'use client';

import Link from 'next/link';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowRight, User, Users } from 'lucide-react';
import TadmLogo from '@/components/tadm-logo';
import { getCurrentUserRole, roleToRedirectPath } from '@/lib/auth';
import { SpeechSettingsCard } from '@/components/speech/speech-settings-card';

export default function WelcomePage() {
  const router = useRouter();

  useEffect(() => {
    (async () => {
      try {
        const current = await getCurrentUserRole();
        if (current) {
          const url = roleToRedirectPath(current.role, current.email);
          router.replace(url);
        }
      } catch (_) {}
    })();
  }, [router]);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-4 dark:bg-gray-900">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <div className="mx-auto mb-4 h-20 w-20">
            <TadmLogo />
          </div>
          <h1 className="font-headline text-3xl font-extrabold tracking-tight text-primary sm:text-4xl">
            Tripartite Alliance for Dispute Management
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
          Please choose the role this system will be used for.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <Link href="/officer" className="group">
            <Card className="h-full transform transition-transform duration-300 ease-in-out hover:-translate-y-1 hover:shadow-xl">
              <CardHeader>
                <div className="mb-4 flex justify-center">
                  <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <User className="h-8 w-8" />
                  </div>
                </div>
                <CardTitle className="text-center font-headline text-2xl">Officer</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-center">
                  Manage conversations and assist visitors.
                </CardDescription>
              </CardContent>
            </Card>
          </Link>

          <Link href="/visitor/counter" className="group">
            <Card className="h-full transform transition-transform duration-300 ease-in-out hover:-translate-y-1 hover:shadow-xl">
              <CardHeader>
                <div className="mb-4 flex justify-center">
                  <div className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary/10 text-secondary">
                    <Users className="h-8 w-8" />
                  </div>
                </div>
                <CardTitle className="text-center font-headline text-2xl">Visitor</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-center">
                  Start a chat session for assistance.
                </CardDescription>
              </CardContent>
            </Card>
          </Link>
        </div>

        {/* Kept outside the role <Link> cards — inside them, opening a select would navigate. */}
        <SpeechSettingsCard />

        <p className="text-center text-xs text-muted-foreground">
          Powered by NCS Pte Ltd
        </p>
      </div>
    </main>
  );
}
